import React from 'react';

import BrandsCarousel from '~/components/ui/BrandsCarousel';
import styles from './BrandsCarouselSection.module.less';

const BrandsCarouselSection: React.FC = (): JSX.Element => (
  <BrandsCarousel className={styles.lightGrayBg} />
);

export default BrandsCarouselSection;
